@if (form) {
    <div>
        @for (group of form.groups; track group) {
            <div [class.hidden]="group.visible === false">
                @if (group.name) {
                    <h4>{{ group.name }}</h4>
                }
                @if (group.description) {
                    <div class="mb-4 muted">{{ group.description }}</div>
                }
                <form class="mb-4" autocomplete="off" (keydown.enter)="formKeyEnterPress($event)" (keyup.enter)="formKeyEnterPress($event)">
                    <div class="invalid-feedback d-block">
                        @for (error of getNonFieldErrors(); track error) {
                            <div>{{ error }}</div>
                        }
                    </div>
                    @for (field of group.fields; track field) {
                        <key-form-builder-field
                            [inline]="inline"
                            [field]="field"
                            [values]="values"
                            [error]="errors && errors[field.id]"
                            (onChange)="onChangeHandler($event)"
                        ></key-form-builder-field>
                    }
                </form>
            </div>
        }
    </div>
}
